import { Chip, ChipProps, SxProps, Theme, useTheme } from '@mui/material';
import { DynamicIcon, Tooltip } from 'src/components';

export const Label = ({
  label,
  backgroundColor = '',
  color,
  isPrivate = false,
  borderRadius = 0.5,
  onDelete,
  sx,
  size,
}: {
  label: ChipProps['label'];
  backgroundColor?: string;
  color?: string;
  borderRadius?: number | string;
  isPrivate?: boolean;
  onDelete?: ChipProps['onDelete'];
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium';
}) => {
  const theme = useTheme();

  return (
    <Chip
      size={size}
      icon={
        isPrivate ? (
          <Tooltip title="Private">
            <DynamicIcon
              name="visibility_off"
              fontSize="1.25rem"
              sx={{
                color: (theme) =>
                  theme.utils.important(theme.palette.custom.OV.sys.onSurfaceVariant),
              }}
            />
          </Tooltip>
        ) : undefined
      }
      label={label}
      deleteIcon={
        <Tooltip title="Remove label">
          <DynamicIcon name="cancel" filled />
        </Tooltip>
      }
      title={String(label)}
      onDelete={onDelete}
      sx={{
        color,
        borderRadius:
          typeof borderRadius === 'number' ? theme.spacing(borderRadius) : borderRadius,
        backgroundColor,
        position: 'relative',
        maxWidth: '8rem',
        '& .MuiChip-label': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '@starting-style': {
          height: 0,
        },

        '& .MuiChip-deleteIcon': {
          position: 'absolute',
          visibility: 'hidden',
          opacity: 0,
          transitionProperty: 'opacity, visibility',
          transitionDuration: '0.25s',
          right: 0,
          background: 'inherit',
          margin: 'auto',
          height: '100%',
          width: '2rem',
          display: 'flex',
          justifyContent: 'center',
          borderRadius:
            typeof borderRadius === 'number' ? theme.spacing(borderRadius) : borderRadius,
        },

        '&:hover .MuiChip-deleteIcon': {
          visibility: 'visible',
          opacity: 0.95,
        },

        ...(sx ?? {}),
      }}
    />
  );
};
